import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

const DeactivateModal = ({ isOpen, toggle, onConfirm, title }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Confirm Deactivation</ModalHeader>
            <ModalBody>
                Are you sure you want to Deactiavte this {title ? title : "Banner"} <strong>permanently</strong>?
                This action cannot be undone.
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="danger" onClick={onConfirm}>Yes, Deactivate</Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeactivateModal;
